import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase'; // Adjust the import path as necessary
import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation
import './users.css'; // Import your CSS for styling

const AllUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'users'));
        const usersList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setUsers(usersList);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching users: ', error);
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const handleUserClick = (userId) => {
    navigate(`/user/${userId}`); // Navigate to user details page
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="all-users">
      <h2>All Registered Users</h2>
      {users.length > 0 ? (
        <table>
          <thead>
            <tr>
              <th>Full Name</th>
              <th>Email</th>
              <th className='noMobile'>Role</th>
              <th className='noMobile'>Group</th>
              {/* Add more columns as needed */}
            </tr>
          </thead>
          <tbody>
            {users.map(user => (
              <tr key={user.id} onClick={() => handleUserClick(user.id)}>
                <td>{user.fullName}</td>
                <td>{user.email}</td>
                <td className='noMobile'>{user.role}</td>
                <td className='noMobile'>{user.group}</td>
                {/* Add more fields as needed */}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No users found</p>
      )}
    </div>
  );
};

export default AllUsers;
